export const resourcesStyles = {
  base: ``,
  gridColumns: {
    base: `
      container
      @container
      text-default-50
      mx-auto
      px-4
      sm:px-6
      py-l
      grid
      grid-cols-12
      grid-flow-row
      auto-rows-min
      gap-l
      sm:gap-x-3
      md:gap-x-4
      lg:gap-x-6
      xl:gap-x-7
      `,
    overview: `
      mt-4
      sm:mt-12
      grid-flow-row-dense
      bg-default-1000
    `,
    detail: ``,
    divider: `
      bg-default-400
      border-none
      h-px
    `,
  },
  cardTitle: {
    base: `
      text-lg
      md:text-xl
      mb-l
      transition-colors
      hover:text-primary
    `,
  },
  cardImage: {
    base: `
      mb-l
      aspect-[2/1]
      transition-all
      hover:scale-110
      hover:shadow-default-900
    `,
  },
  cardDate: {
    base: `
      text-default-400
      tracking-wide
      uppercase
      text-sm
    `,
  },
  cardCategory: {
    base: `
      h-[22px]
      inline-flex
      items-center
      text-sm
      text-primary-400
      uppercase
      tracking-wide
      font-bold
      mb-4
    `,
  },
  cardPill: {
    base: `
      text-xxxxs
      text-default-1000
      inline-flex
      items-center
      uppercase
      bg-warning
      px-s
      py-xs
      rounded-md
      mr-m
      h-[22px]
    `,
  },
  cardOverlay: {
    base: `
      absolute
      inset-0
      flex
      items-center
      justify-center
      pointer-events-none
    `,
    text: `
      border-t
      border-t-default-50
      border-b
      border-b-default-50
      py-xs
      w-32
      text-center
      text-md
      font-normal
      hover:text-default-50
    `,
  },
  sidebarTitle: {
    base: `
      text-xxs
      font-bold
      mb-s
    `,
  },
  sidebarDescription: {
    base: `
      text-xxs
      text-default-400
      leading-normal
      mb-m
    `,
  },
}
